import styled from "styled-components";
import colors from "../../../../../../config/colors";
import { isMobile } from "../../../../../../utils/common";

export const DurationSelectorContainer = styled.div`
    display:flex;
    align-items:center;
    justify-content:flex-end;

    ${
        isMobile() && `
            justify-content:center;
        `
    }
`;

export const DurationOption = styled.div`
    padding:2px 15px;
    font-weight:${props=>props.active?"bold":"normal"};
    border:solid 1px ${colors.darkPrimary};
    background-color: ${ props=> props.active? colors.darkPrimary : colors.background};
               color: ${props=>props.active? colors.background : colors.darkPrimary};
    cursor:pointer;
    border-right:none;
    transition:all 0.2s;
    :first-of-type{
        border-radius: 10px 0px 0px 10px;
    }
    :last-of-type{
        border-right:solid 1px ${colors.darkPrimary};
        border-radius: 0px 10px 10px 0px;
    }

    ${props=>props.disabled && `filter:saturate(0);cursor:not-allowed;`}
`;


export const DurationLabel = styled.div`
    margin-right:10px;
`;
export const DurationOptionList = styled.div`
display:flex;
align-items:center;`;